import {createSlice} from '@reduxjs/toolkit';

// DELETE functionality has been removed - seat classes now use status toggle (ACTIVE/INACTIVE)
// This file is kept as a stub to maintain backwards compatibility

interface DeleteSeatClassSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteSeatClassSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'aircrafts/delete-seat-class',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSuccess: (state, action) => { state.success = action.payload },
    setError: (state, action) => { state.error = action.payload }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;
export default stateSlice.reducer;
